<template>
    <div>
        <v-dialog v-model="dialog_activate_business" no-click-animation scrollable :overlay="false" fullscreen persistent transition="dialog-bottom-transition">
            <v-card>

                <v-toolbar fixed flat>
                    <v-toolbar-side-icon @click="$parent.fn_closeDialog">
                        <img src="../../../assets/back-icon.svg" style="margin-top:5px; width:28px"/>
                    </v-toolbar-side-icon>
                    <v-toolbar-title class="ml-5">Activate Business</v-toolbar-title>
                </v-toolbar>

                <div class="hastoolbar">
                    <v-progress-linear indeterminate color="primary" v-if="!businesses"></v-progress-linear>
                    <v-card-text full-height nopadding v-if="businesses && businesses.length">
                        <v-list two-line subheader full-width>
                            <div v-for="(item, index) in businesses" :key="index">
                                <v-list-item>
                                    <v-list-item-content>
                                      <v-list-item-title>{{item.BusinessName}}</v-list-item-title>
                                      <v-list-item-subtitle>Created On: {{item.CreatedOn}}</v-list-item-subtitle>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-btn color="primary" outlined small @click="openDialogConfirmation(item)">Activate</v-btn>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-divider v-if="businesses.length-1 != index"></v-divider>
                            </div>
                        </v-list>
                    </v-card-text>

                    <div class="pt-3" v-if="!businesses || !businesses.length" grey-color center-align>
                        <span>{{!businesses ? 'Getting Businesses...' : 'No business found to activate!'}}</span>
                    </div>                 
                </div>

            </v-card>

        </v-dialog>
    </div>
</template>

<script>
    export default{
        props:['businesses', 'openDialogConfirmation'],
        data(){
            return{
                dialog_activate_business:false
            }
        },
        methods:{
            openDialogWeb: function () {
                this.dialog_activate_business = true;
            },
            closeDialogWeb: function () {
                this.dialog_activate_business = false;
            },
        }
    }
</script>